module.exports = __webpack_public_path__ + "common/sidebar/icon-np-credit-e6c9afbb5e4a38b3314c2221373a5cb3.svg";